module.exports = __webpack_public_path__ + "img/home.9fba4d8e.jpg";